import styled from "@emotion/styled";
import { createRef, forwardRef, RefObject, useEffect, useMemo, useRef } from "react";
import _ from "lodash"
import { useWindowSize } from "react-use"
//@ts-ignore
import interpolatingPolynomial from 'interpolating-polynomial'
//@ts-ignore
import linearInterpolator from 'linear-interpolator'
//import { linearInterpolation } from "simple-linear-interpolation";


const HiloWrapper = styled.div`
    display: flex;
    justify-content: center;
`

const Path = styled.path`
    z-index: 3;
    will-change: transition, stroke-dasharray;
`
const StyledSvg = styled.svg`
    position: absolute;
`


type LineSectionConfig = {
    sectionEnd: number;
    sectionLength: number;
}

function getHeightPercentage(pxs: number): number {
    return pxs / (6402 * 340 / 380)
}


const configs2: LineSectionConfig[] = [
    {
        sectionEnd: getHeightPercentage(0),
        sectionLength: 0,
    },
    {
        sectionEnd: getHeightPercentage(300),
        sectionLength: 0.2,
    },
    {
        sectionEnd: getHeightPercentage(784),
        sectionLength: 0.37,
    },
    {
        sectionEnd: getHeightPercentage(1126),//0,048157248
        sectionLength: 0.38
    },
    {
        sectionEnd: getHeightPercentage(1354),//0,048157248
        sectionLength: 0.40,
    },
    {
        sectionEnd: getHeightPercentage(1696),//0,048157248
        sectionLength: 0.42,
    },
    {
        sectionEnd: getHeightPercentage(3292),//0,048157248
        sectionLength: 0.52,
    },
    {
        sectionEnd: getHeightPercentage(4432),//0,048157248
        sectionLength: 0.62,
    },
    {
        sectionEnd: getHeightPercentage(4945),//0,048157248
        sectionLength: 0.70,
    },
    {
        sectionEnd: getHeightPercentage(5208),//0,048157248
        sectionLength: 1,
    },
]

const f = interpolatingPolynomial(configs2.map(({ sectionEnd, sectionLength }) => ([sectionEnd, sectionLength])))
const x = linearInterpolator(configs2.map(({ sectionEnd, sectionLength }) => ([sectionEnd, sectionLength])))

const y = interpolatingPolynomial(configs2.map(({ sectionEnd, sectionLength }) => ({ x: sectionEnd, y: sectionLength })))

type LineSectionColorConfig = {
    atLengths: number[];
    color: string;
}

const colorConfigs: LineSectionColorConfig[] = [
    {
        atLengths: [0, 18300],
        color: "#9fcd39"
    },
    {
        atLengths: [18300, 27000],
        color: "white"
    },
    {
        atLengths: [20813, 29726],
        color: "#9fcd39"
    },
    {
        atLengths: [29726, 32368],
        color: "white"
    },
    {
        atLengths: [32368, 45000],
        color: "#9ecb3a"
    }
]



const sumSectionEnd = (index: number, pathHeight: number) => configs2.slice(0, index).reduce((prev, current) => prev + ((current.sectionEnd * pathHeight)), 0)
const sumSectionLength = (index: number, pathLength: number) => configs2.slice(0, index).reduce((prev, current) => prev + (current.sectionLength * pathLength), 0)


interface IProps {
    width: number;
    height: number;
}

export const HiloMobile: React.FC<IProps> = ({ width, height }) => {

    const wrapperRef = useRef<HTMLDivElement>(null)
    useEffect(() => {
        const wrapperEl = _.get(wrapperRef, "current", null)
        if (wrapperEl) {
            //@ts-ignore
            const pathLength = wrapperEl.firstChild?.firstChild?.getTotalLength();
            const pathHeight = height//16280//Math.min(height, 16280)

            const maxScrollTop = pathHeight - window.innerHeight;
            const scrollAdvantage = 200

            const renderPath = () => {
                let length = 0;
                let percentDone = 0;
                const scrollPoint = window.scrollY + scrollAdvantage
                let sectionIndex = 0
                while (sectionIndex < configs2.length && configs2[sectionIndex].sectionEnd * pathHeight < scrollPoint) {
                    sectionIndex++
                }
                percentDone = scrollPoint / pathHeight
                length = x(percentDone) * pathLength

                console.log({ length, scrollPoint })

                //@ts-ignore
                for (const [index, svg] of Array.from(wrapperEl.children).entries()) {
                    let strokeDasharrayValue = ""
                    let transitionValue = ""
                    if (length > colorConfigs[index].atLengths[1]) {
                        strokeDasharrayValue = [colorConfigs[index].atLengths[1] - colorConfigs[index].atLengths[0], pathLength].join(' ')
                    }
                    else if (length > colorConfigs[index].atLengths[0]) {
                        //@ts-ignore
                        strokeDasharrayValue = [Math.max(length - colorConfigs[index].atLengths[0], 0), pathLength].join(' ');
                        transitionValue = `stroke-dasharray ${scrollPoint > 500 ? 300 : 1000}ms linear`
                    }
                    else {
                        strokeDasharrayValue = [0, pathLength].join(' ')
                    }
                    //@ts-ignore
                    if (svg.firstChild.style.strokeDasharray != strokeDasharrayValue) {
                        //@ts-ignore
                        svg.firstChild.style.strokeDasharray = strokeDasharrayValue
                    }
                    //@ts-ignore
                    if (svg.firstChild.style.transition != transitionValue) {
                        //@ts-ignore
                        svg.firstChild.style.transition = transitionValue
                    }
                }

            }
            renderPath()
            document.addEventListener("scroll", _.throttle(renderPath, 300))
            //document.addEventListener("scroll", renderPath)
        }

    }, [wrapperRef])

    //console.log({ pathWidth, width, width2: width - 200 })

    return <HiloWrapper ref={wrapperRef}>
        {colorConfigs.map(({ atLengths, color }, index) =>
            <StyledSvg width="340.51" /*height="6402.564" */preserveAspectRatio="none" viewBox={`0 0 380.51 6402.564`} >
                <Path id={`path-${index}`} strokeDasharray="0 47184.3203125" d={pathCoords} transform="translate(-3402.153 -223.508)" fill="none" stroke={color} strokeDashoffset={-atLengths[0]} strokeWidth={2} />
            </StyledSvg>)}

    </HiloWrapper>
}

export default HiloMobile


const pathCoords = "M3405,224.008h337.318c13.866,0,21.726,13.857,21.726,21.726s-3.7,23.8-18.954,23.8H3431.209c-5.543,0-9.6-3.98-9.6-8.832s2.053-10.451,8.771-10.264,326.206.746,330.125.187,9.331-1.12,9.331-8.025-2.24-10.637-9.331-11.01-328.631.187-332.364.187-10.077,5.6-10.077,15.116,5.412,13.81,9.144,13.81H3757.9c2.986,0,14.743,1.12,14.183,15.3s-6.9,17.915-14.183,17.915-326.765,0-329.751-.373-5.225-1.866-5.225-4.665,2.613-4.479,5.225-4.292,328.072-2.613,332.364-2.613,6.532,2.986,6.158,6.158a6.787,6.787,0,0,1-7.092,5.785c-3.732-.187-330.5-.56-334.417-.373s-7.092,3.732-7.092,10.637,5.226,8.025,7.092,8.025,332.737.187,335.35.187,2.986,4.292,0,4.292-330.311-.56-334.417-.373-4.106,8.584,0,8.4,326.765-.187,334.417-.187,8.4,15.676,0,15.676-326.765.373-332.364.187-7.465-11.757-.933-11.757,321.913.746,333.3.746,9.891,23.887-.933,23.887-326.952-.187-333.484.187-8.024,14.556,1.12,14.369,327.325.56,333.3.373,5.412-8.958,0-8.958-327.512-.373-336.843.187-14.37,35.084,2.426,35.457,328.445.373,336.1.187,8.584-18.662,0-18.662-319.487.187-334.977.373-15.489,28.179,0,27.992,320.234.187,332.364.373,16.423,27.619-1.306,27.246-318.181-3.732-330.125-3.359-14,24.82,0,25.193,295.6-1.12,310.9-2.053,12.5-22.581,1.493-22.954-320.607-10.637-320.607-10.637,315.828,15.277,335.549,16.876,17.056,35.178-2.665,35.711-309.137,0-320.33,0-9.061,15.99,0,15.99h332.589l-336.931-8.528h322.541c11.726,0,16.523,21.853,0,21.853s-300.076-2.132-315.533-2.132-20.254,25.051,0,25.584,292.081-.533,310.2,0,17.589,23.452,0,24.518-315.266,6.929-320.2,6.929-8.043-3.694,2.7-5.293,336.5-37.389,339.367-37.831,3.644-5.852-2.65-5.632-307.143,5.422-321.5,5.853-14.355,25.983,1,25.983,286.965.275,306.607-.135,22.178,26.65,0,27.06-316.146.82-320.656,1.23-6.56,4.92,0,4.1,327.587.82,332.507.41,5.74,5.33,0,5.33-327.385-.41-327.385-.41l332.07,35.67s-326.947-4.92-334.734-4.92-7.792-12.3,0-12.71,307.166.41,318.2.41,12.748,22.96,0,23.37-322.831-.82-322.831-.82l334.682,11.07s-322.667.82-332.507.82-9.02,6.56-9.43,13.12,0,156.2,0,163.179,2.87,13.94,12.71,13.94,210.738-.41,233.7-.41,26.65,37.31,0,37.31-144.33-.553-166.458,0-25.42-32.39,0-32.8,146.479-.854,169.526.845,24.417,34.76-1.456,36.633-145.214.485-168.071,0-25.525-35.9-1.75-37.477,162.239-.477,174.533.007S3689.6,836.9,3688.938,844.3c4.086-.11,27.606,0,32.244,0s34.075,7.229,34.075,40.345-.315,254.829-.631,269.021-13.877,35.953-36.9,35.638-188.6,0-209.729.315-20.185,35.638,0,36.269,147.6.946,167.468.315,22.077-32.8,0-32.8-146.968-.631-170.622,0-21.761,38.161,3.154,37.846,141.291.315,167.468,0,23.969-38.477-2.523-37.846-158.653.618-171.819.957-13.676,15.2-13.676,15.2-30.131-.043-41.776,0-25.231,8.2-25.231,27.7.99,679.286,1.177,689.736,7.651,16.982,16.236,16.609,289.816-.373,312.77-.373,24.447,37.7,0,37.51-284.59.373-304.745-.373-20.715-32.471-.933-32.658,287.017.187,310.157.56,27.619,37.137,0,37.51-315.2-.373-323.78,0-15.116,8.584-14.929,19.408.412,900.2.654,911.848,13.1,14.8,20.379,14.313,237.992-.485,261.04,0,25.473,43.668-2.183,43.426-190.443.243-216.158.243-24.26-38.331,0-38.331,196.993.243,222.708.243,25.473,44.154,0,44.154-247.939,0-256.43.243-16.74,8.006-16.74,20.864-.484,487.388-.727,497.82,6.065,11.645,12.615,11.4,214.945-.485,237.265,0,22.077,36.633,0,36.875-185.591.485-206.939.242-21.592-31.053,0-32.266,189.957-.242,212.277,0,22.8,37.118-1.213,37.118-189.957-.242-212.519-.242-23.775-36.148,3.154-36.875,196.246.027,212.47,0,19.215,37.118-3.1,37.118-206.111.036-206.111.036.534,57.311.174,81.058c12.233,1.106,7.9,15.121-.508,14.1s-9.77-13.083-.342-13.337,8.664,11.807.849,11.892-7.05-11.977,0-11.892,12.06,13,0,13.337c-.083,5.261-.068,200.706.044,268.113v.016c12.2.254,8.932,14.126,0,13.922s-8.932-13.015,0-13.115,9.032,12.364.538,12.314-7.761-11.46-.538-11.711,12.63,13.118,0,13.269c.036,4.373.042,157.275.042,168.912,10.788,0,9.683,14.61,0,14.44s-7.815-13.931,0-13.676,9.683,13.421,0,13.676-7.135-13.336,0-12.911,9.6,12.486,0,12.911c-.085,4.417-.359,311.285-.359,322.445s10.675,16.254,21.349,16.254,209.851-1.456,248.667-.728,33.479,62.349,2.911,62.591-284.815-.243-312.714-.243-33.964-54.585,0-54.585,280.206-.485,312.714.243,39.787,61.863-2.911,62.591-294.761.485-309.8.728-19.408,10.674-18.923,22.319.244,486.513.244,499.576,9.144,15.676,20.528,15.489,276.028-.872,310.718-.187,34.711,47.028,1.68,46.841-277.686-.187-311.277-.187-32.1-40.682-4.479-40.869,281.792-.559,311.277.187,31.912,46.094,2.8,46.654-320.7.032-320.7.032,320.618-.064,332.508-.032,19.27,8.642,18.86,18.892.407,284.535,0,297.245-6.15,20.09-25.42,20.09-179.989-.41-184.5,0-5.74,9.43,0,9.84,8.2-.41,13.94,0,7.79,12.3,0,12.3-11.067.362-17.22,0-9,11.658,0,12.3,8.6,0,17.22,0,8.241,13.12,0,13.12h-17.22c-6.573,0-6.97,12.3,0,12.3h17.22c8.62,0,6.56,12.3,0,12.3h-99.624c-86.616,0-108.793,165.035,0,165.035h232.12c50.657,0,65.836-132.343-21.48-132.343h-227.27c-70.676,0-80.4,145.508,0,145.508h227.27c75.529,0,81.068-134.376,9.008-135.808s-148.973-1.386-226.577,0-91.606,148.973-9.7,148.973h242.515c9.566,0,8.633,13.86,0,13.86h-9.283c-5.043,0-6.158,9.875,0,9.875H3714.8c5.225,0,5.6,8.958,0,8.958h-13.623c-5.042,0-5.052,8.4,0,8.4H3714.8c5.785,0,6.721,10.264,0,10.264h-13.623c-5.07,0-6.534,9.145,0,9.145s6.352-.363,13.623,0,7.84,11.57,0,11.57-8.221-.491-13.623,0-5.412,10.824,0,10.824h15.863c2.675,0,3.639,3.986,3.391,7.713s-.371,101.8,0,108.354,1.122,14.76-10.768,14.76-173.235,1.235-208.935,2.255-57.031,17.868-57.031,74.086v282.489c0,29.314,24.518,66.625,59.163,69.29s103.4,0,139.645,0,68.223-18.655,69.29-75.153,2.026-236.172,0-268.045-33.206-72.753-120.511-73.447-113.635,141.351-37.417,178.074,150.358-31.181,131.65-98.392-91.462-88.69-144.815-65.825-61.668,45.038-61.668,97.7-.693,194.011.693,219.648,32.566,71.368,100.47,81.069,66.3,7.516,74.513,7.7,11.01,4.852-1.866,6.158S3492.2,6385.3,3482.6,6387.436s-9.594,11.193,0,11.726,269.969,1.656,281.614,2.141,6.793,5.095-2.426,5.095-334.063-2.912-342.8-2.426-7.521,9.7-.97,9.7,346.436-2.911,352.5-2.911,6.308,7.035,0,7.278-351.288,8.249-350.318,8.249,292.578-7.521,306.649-8.249,9.219,1.456,0,2.184-307.862,9.7-312.229,9.947-4.852,5.095,0,5.095,352.5-3.882,358.809-4.125,6.065,3.64,0,4.367-350.075,5.337-355.412,5.337-5.58,3.882,0,3.882,266.135,7.036,305.194,8.249,42.213,58.467,4.609,59.923-191.656,1.212-222.466.242-40.515-57.982-3.154-59.68,205.241-1.455,231.2-.485,37.361,61.135-6.55,61.863-300.1-.243-307.134.243-4.609,3.639,0,3.4,353.471,3.154,353.471,3.154l-353.471-.728,353.714,7.08-353.229-4.1s341.114,6.15,347.674,6.56,6.56,4.1,0,4.92-314.058-5.74-328.818-5.74-11.48,13.53,0,13.53,343.578-3.28,343.578-3.28l-364.617,16.4,357.237-11.48s-351.216,15.99-357.237,16.4-3.819,6.15,0,6.15,364.617-9.84,364.617-9.84l-367.358,11.89,293.148,2.46H3420.206s343.949,9.43,352.986,9.43,7.438,9.43.243,9.84-358.153,2.46-358.153,2.46l346.858,4.1-346.858-1.64s334.968,9.021,350.138,9.43,13.12,18.45,0,18.86-306.678.82-323.488,1.23-15.17-20.09,0-20.5,323.488,3.69,323.488,3.69l-363.258,6.56"